module.exports = __webpack_public_path__ + "static/img/place_4.8c1f21dd.png";